/**
 * @typedef {object} CopyEntry
 * @property {string} defaultMessage - English copy used until react-intl wiring is complete.
 * @property {string} id - Message id aligned with `src/translations/en.js`.
 */

/**
 * Resolve copy for display. Today returns `defaultMessage`; swap to
 * `intl.formatMessage(entry)` when components are wired to react-intl.
 *
 * @param {CopyEntry} entry
 * @returns {string}
 */
export const copyText = (entry) => entry.defaultMessage;
